import humps from 'humps';
import api from '@/service/driver';
import createStore from '@/store/base/create-store';
const { state, actions, mutations } = createStore(api);
import { PAGE_TYPE, pageTypes } from '@/config/enums';
import { INVITATION_CHANNEL_CODE } from '@/config/enums';
import { buildUrlWithQuery } from '@/util/url.js';
import { UrlConfig } from '@/util/env.js';

const MIGRATE_SCENE = 'nio_drive_h5_migrate';

const tempState = {
    redirectUrl: '', // 重定向地址
    // 页面配置
    pageOption: {
        accountId: '', // 邀请人accountId，无需加密
        campaignSourceCode: '', // 来源code cykKliLxZK
        title: '预约试驾', // 页面title
        bannerImg: '', // bannerImg
        bannerImgTop: '', // banner图距离上方高度(默认：65.0666vw)，vw单位，计算：按照设计图375，(像素尺寸)*100/375
        backgroundStyle: {}, // 背景模块样式,对象参数 nio summer: backgroundImage: 'linear-gradient(#00bdbd, #fff3e4)',height: '100vh',width: '100vw'
        backUrl: '', // 成功回调页面
        formTitle: '预约试驾', // 表单title
        activity: '', // 活动内容
        buttonText: '立即预约', // 按钮文案
        inviterChannel: '', //涟漪邀请渠道
        fellowEmpDomain: undefined, // leads归属fellow
        registerEmpDomain: undefined, // 留资fellow
        inviteOrderId: undefined, // 邀请记录单id（代好友约试驾）
        isFormItemRow: true, // 表单行展示
        isHidderName: true, // 隐藏name字段
        isHidderCar: false, // 隐藏car字段
        isHidderConfigurator: false, // 隐藏配置器
        isHidderInviter: false, // 隐藏邀请人信息
        isHidderInvitationCode: false, // 隐藏邀请码

        nickname: '', // 用户昵称
        carType: 'ES7',
        platform: '', // 来源
        eventTrackSubmit: 'niosummer_join_click', // 提交埋点key
        eventTrackJoin: '', // 进入埋点key
        uniqueKey: '' // url 参数 unique_key
    },
    // 切换页面保存信息备份
    pageOptionBak: {},
    pageType: '', // ../config/enums.js pageType
    accountId: '', // 邀请人id
    // 是否nioapp打开
    isNIOApp: false,
    showCustomHeader: false,
    // 成功页面
    successStatus: '',
    // 成功数据
    succeedData: {},
    // 当前车型
    carType: 'es7',
    // 访问时间
    accessTime: new Date().getTime(),
    // 登陆信息
    loginInfo: {},
    // 试驾单详情
    driveOrderInfo: {},
    // 是否可被邀请
    inviteable: true,
    // 敬请期待
    comingSoon: false,
    ...state
};

const tempMutations = {
    ...mutations,
    setRedirectUrl(state, data) {
        state.redirectUrl = data;
    },
    setPageOption(state, data) {
        const sourceData = data;
        if (sourceData.carModel) {
            sourceData.carType = sourceData.carModel;
        }
        state.pageOption = _.merge(state.pageOption, sourceData);
        if (state.pageOption.userAccount) {
            state.pageOption.accountId = state.pageOption.userAccount;
        }
        state.carType = (state.pageOption.carType || 'es7').toLowerCase();
    },
    setPageType(state, data) {
        state.pageType = data || 'driver';
    },
    setAccessTime(state, data) {
        state.accessTime = data;
    },
    setIsNIOApp(state, data) {
        state.isNIOApp = data;
    },
    setShowCustomHeader(state, data) {
        state.showCustomHeader = data;
    },
    // /components/succeed/config.js 的 key
    setSuccessStatus(state, data) {
        if (_.isObject(data)) {
            state.successStatus = data.status;
            state.succeedData = data.data || {};
        } else {
            state.successStatus = data;
        }
    },
    setCarType(state, data) {
        state.carType = (data || 'es7').toLowerCase();
        if (state.carType === 'et5') {
            state.carType = 'pegasus';
        }
        state.pageOption.carType = state.carType;
    },
    setLoginInfo(state, data) {
        state.loginInfo = data || {};
    },
    setDriveOrderInfo(state, data) {
        state.driveOrderInfo = data || {};
    },
    setUserInviteable(state, data) {
        state.inviteable = data;
    },
    setComingSoon(state, data) {
        state.comingSoon = data;
    }
};

const tempActions = {
    ...actions,
    /**
     * 初始化
     * @param {*} param0 
     * @param {*} param 
     */
    init({ dispatch, commit, state }, param) {
        const {
            pageType,
            type,
            carType,
            accountId,
            campaignSourceCode,
            inviteOrderId,
            formTitle,
            inviterChannel
        } = param;
        commit('setCarType', type || carType);
        commit('setPageType', pageType);
        // 邀请acountid
        if (accountId) {
            commit('setPageOption', { accountId });
        }
        // 来源
        if (campaignSourceCode) {
            commit('setPageOption', { campaignSourceCode });
        }
        if (inviterChannel) {
            commit('setPageOption', { inviterChannel });
        }
        // 邀请记录代好友约试驾
        if (pageType === PAGE_TYPE.APPFRIENDCONFIRM) {
            commit('setPageOption', { inviteOrderId, formTitle });
        }
        // 初始化
        return Promise.all([dispatch('pageOptionInit', param)]).then(
            () => state.pageOption
        );
    },
    /**
     * decide 是否跳转
     */
    async decideIfRedirectToNewPage({ dispatch, commit, state }, param) {
        // 代友预约暂时不切换
        const pageType = param.pageType;
        if (
            [PAGE_TYPE.APPFRIENDCONFIRM, PAGE_TYPE.APPFRIEND].includes(pageType)
        ) {
            return;
            // 老版本的 friend和receive正常跳转
        }
        // 走开关
        try {
            const redirect = await dispatch('simpleSwitch', {
                scene: MIGRATE_SCENE,
                host: param.host
            });
            console.log('[Drive] redirect => ', redirect.data);

            if (!redirect.data) return;
        } catch (e) {
            console.error('[Drive simpleSwitch] load error => ', e.message);
        }

        // 生成uniqueKey
        const redirectUrl = await getRedirectUrl(dispatch, param);
        if (!redirectUrl) {
            return;
        }

        commit('setRedirectUrl', redirectUrl);
        return true;
    },
    /**
     * 页面配置初始化 pageOption
     */
    pageOptionInit({ dispatch, commit, state }, param) {
        const { host, unique_key, uniqueKey, id } = param;
        if (unique_key || uniqueKey || id) {
            return dispatch(
                'vomDecode',
                {
                    key: unique_key || uniqueKey || id,
                    host
                },
                { root: true }
            ).then(res => {
                // 解密统一参数
                if (res.result_code === 'success') {
                    commit('setPageOption', JSON.parse(res.data.value));
                }
                return state.pageOption;
            });
        }
    },
    // /**
    //  * nio app 试驾单
    //  */
    // getTestDriveOrdersInfo({ dispatch, commit }, param) {
    //     // ../config/enums.js
    //     commit('setDriveOrderInfo', {});
    //     return dispatch('userIdentityTestDriveStatus', param).then(res => {
    //         const orderList = res.data.test_drive_orders || [];
    //         if (orderList.length > 0) {
    //             const orderItem = orderList[0];
    //             commit('setDriveOrderInfo', orderItem);
    //             dispatch('getOrderInfo', {
    //                 ...param,
    //                 order_no: orderItem.order_no
    //             });
    //             ['booked', 'arranged', 'driving'].includes(orderItem.status) &&
    //                 commit('setPageType', 'appDriverOrder');
    //         } else {
    //             commit('setPageType', 'appDriver');
    //         }
    //     });
    // },
    getOrderInfo({ dispatch, commit }, param) {
        return dispatch('userIdentityTestDriveByOrderNo', {
            ...param,
            order_no: param.order_no
        }).then(res => {
            if (res.data) {
                commit('setDriveOrderInfo', res.data);
            }
            return res;
        });
    },
    /**
     * 试驾单列表
     * @param {*} param0 
     * @param {*} param 
     */
    getTestDriveOrders({ dispatch, commit, state }, param) {
        // ../config/enums.js
        commit('setDriveOrderInfo', {});
        return dispatch('testDriveOrderList', param).then(res => {
            const orderList = res.data.list || [];
            if (orderList.length > 0) {
                const orderItem = orderList[0];
                dispatch('getOrderInfo', {
                    ...param,
                    order_no: orderItem.order_no
                })
                    .then(orderInfoRes => {
                        if (orderInfoRes.data) {
                            commit('setDriveOrderInfo', orderInfoRes.data);
                            const tempCarType = (orderInfoRes.data.car_type ||
                                'es6'
                            )
                                .toLowerCase()
                                .split(',')[0]; // fab二维码创建的试驾单可能为多车型
                            commit(
                                'setCarType',
                                tempCarType === 'et5' ? 'pegasus' : tempCarType
                            );
                        }
                    })
                    .catch(() => {
                        commit('setDriveOrderInfo', orderItem);
                    });
                ['booked', 'arranged', 'driving'].includes(orderItem.status) &&
                    commit('setPageType', PAGE_TYPE.APPDRIVERORDER);
            } else {
                if (!pageTypes.includes(state.pageType)) {
                    commit('setPageType', PAGE_TYPE.APPDRIVER);
                }
            }
        });
    },
    getUserInviteable({ dispatch, commit, state }) {
        return dispatch('userInviteable', {
            headers: { authorization: state.loginInfo.access_token }
        }).then(res => {
            commit('setUserInviteable', res.data);
        });
    }
};
const tempGetters = {
    getConfigCarInfo(state) {
        const carInfo = state.configCarData[state.carType];
        if (carInfo) {
            return carInfo;
        }
        return {};
    },
    campaignCode(state) {
        const pCode = state.pageOption.campaignSourceCode;
        const dCode = state.getCompatibleCodeData.campaign_code.appDrive;
        return pCode || dCode || '';
    }
};

const store = {
    namespaced: true,
    strict: true,
    state: tempState,
    actions: tempActions,
    mutations: tempMutations,
    getters: tempGetters
};
export default store;

/**
 * tools: 切换页面
 */
// 参数兼容
async function getRedirectUrl(dispatch, param) {
    try {
        const { unique_key, uniqueKey, id, host, origin } = param;
        let uniqueKeyContent = {};

        const key = unique_key || uniqueKey || id;
        if (key) {
            const uniqueKeyParams = await dispatch('decodeUniqueKey', {
                key: unique_key || uniqueKey || id,
                host: host
            });

            try {
                uniqueKeyContent = JSON.parse(uniqueKeyParams.data);
            } catch (error) {
                console.log('解析uniqueKey失败', error);
            }
        }

        const {
            campaignSourceCode,
            campaignCode,
            type,
            carType,
            carModel,
            accountId,
            userAccount,
            inviterChannel,
            fellowEmpDomain,
            registerEmpDomain,
            activityId
        } = humps.camelizeKeys({
            ...param,
            ...uniqueKeyContent
        });

        // 车型转换
        const { data: carTypeConfig } = await dispatch(
            'configCarV2',
            { mode: 'testdrive', host: param.host },
            { root: true }
        );
        const carTypeLowerCase = (type ||
            carType ||
            carModel ||
            'ES7'
        ).toLowerCase();
        const realCarType = ((carTypeConfig[carTypeLowerCase] &&
            carTypeConfig[carTypeLowerCase].carType) ||
            carTypeLowerCase
        ).toUpperCase();

        const params = {
            campaignCode: campaignSourceCode || campaignCode,
            carType: realCarType,
            inviterAccountId: accountId || userAccount,
            inviterChannel: inviterChannel || INVITATION_CHANNEL_CODE.page,
            inviterBrand: 'nio',
            fellowEmpDomain,
            registerEmpDomain,
            activityId
        };

        const { data: scene } = await dispatch('encodeLeadsUniqueKey', {
            ...params,
            host: param.host
        });

        const hostUrl = UrlConfig['apollo'][param.env];
        const newLeadsPage = `${hostUrl}/hana-pro/pages/drive`;
        const targetLink = buildUrlWithQuery(newLeadsPage, {
            scene,
            origin,
            is_nav_show: false
        });

        console.log('[Drive] targetLink => ', targetLink);
        return targetLink;
    } catch (e) {
        console.error(
            '[Drive decideIfRedirectToNewPage] load error => ',
            e.message
        );
    }
}



// WEBPACK FOOTER //
// ./src/store/driver.js